import * as React from 'react';

import FilePhotoshop32 from './FilePhotoshop32';

export const filePhotoshop32 = () => <FilePhotoshop32 />;

export default {
    title: 'Icon|Content|FilePhotoshop32',
    component: FilePhotoshop32,
    parameters: {
        notes: "`import FilePhotoshop32 from 'box-ui-elements/es/icon/content/FilePhotoshop32';`",
    },
};
